module.exports = __webpack_public_path__ + "static/media/ad-suggested-vertical.2db77ac0.png";